// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Tutorial_videoWrapper__2_hlB"};